import _ from "lodash";
import {
  GetAttachmentFilesByMemoId,
  GetRefDocFormTable,
} from "../Services/MemoService";
import { generateQuickGuid } from "./GenerateGuid";
import { getDefValueInTemplate } from "./RequestScreenHelper";
export type RefResult = {
  items: any[];
  listRefDocsDetail: any[];
  listFileAttachDetails?: any[] | null;
  errorMessage?: string;
};
export const onChanceRef = async (
  refTempSelected: any,
  memoDetail: any,
  listFormNames: any,
  refAttribute: any,
  currentTemp: any,
  isDelete? :boolean,
  userData?: any
) => {
  let result: RefResult = {
    items: [],
    listRefDocsDetail: [],
    listFileAttachDetails: null,
  };

  try {
    console.log(memoDetail ,refTempSelected ,isDelete ,"Test");
    
    if (memoDetail) {
      if(isDelete) refTempSelected =isDelete
      if (
        refTempSelected !== undefined &&
        refTempSelected !== null &&
        refTempSelected.length > 0
      ) {
        let template_desc = currentTemp;
        let _listRefDocsDetail: any[] = [];
        let listFileAttachDetails: any[] = [];
        let docsCode: any[] = [];
        let refTemp: any;
        const refColumn = JSON.parse(listFormNames?.RefDocColumn);
        if (
          listFormNames?.RefTemplate !== "" &&
          listFormNames?.RefTemplate !== null
        ) {
          refTemp = JSON.parse(listFormNames?.RefTemplate);
          refTemp.map((temp: any) => {
            if (temp.DocumentCode !== "") {
              docsCode.push(temp.DocumentCode);
            }
          });
        }
        console.log(refTempSelected ,"test");
        
        for (const refTems of refTempSelected) {
          let refDocDetail = {
            memoRefdoc_id: refTems.MemoId,
            doc_no: refTems.DocumentNo,
            template_ID: listFormNames?.template_id,
            template_Name: listFormNames?.template_name,
            memoSubject: listFormNames?.subject,
          };
          if (refTems.MAdvancveForm) {
            let valibCol: any[] = [];
            _listRefDocsDetail.push(refDocDetail);
            const selectedColumn = JSON.parse(refTems?.MAdvancveForm);

            refColumn.map((col: any) => {
              if (col.Value !== null && col.Value !== "") {
                if (col.Value === "_DocumentNo") {
                  col.ControlValue = { value: refTems.DocumentNo };
                } else if (col.Value === "_DocumentAmount") {
                  col.ControlValue = { value: refTems.Amount };
                } else if (col.Value === "_RequestorEmployeeName") {
                  col.ControlValue = { value: refTems.RNameEn };
                } else if (col.Value === "_RequestorEmployeePositionTh") {
                  col.ControlValue = { value: refTems.RPositionTh };
                } else if (col.Value === "_RequestorEmployeePositionEn") {
                  col.ControlValue = { value: refTems.RPositionEn };
                } else if (col.Value === "_RequestorEmployeeDepartmentTh") {
                  col.ControlValue = { value: refTems.DepartmentTh };
                } else if (col.Value === "_RequestorEmployeeDepartmentEn") {
                  col.ControlValue = { value: refTems.DepartmentEn };
                } else if (col.Value === "_InformationFormName") {
                  col.ControlValue = { value: refTems.TemplateName };
                } else if (col.Value === "_InformationRequestDate") {
                  col.ControlValue = { value: refTems.RequestDate };
                } else if (col.Value === "_InformationCompany") {
                  col.ControlValue = { value: refTems.CompanyName };
                } else {
                  let selColLabel = "";
                  if (col.Value.indexOf("_") !== -1) {
                    let colLabel = col.Value.split("_");
                    selColLabel = colLabel.pop();
                  } else {
                    selColLabel = col.Value;
                  }
                  if (col.TypeControl === "Table") {
                    let sourceRow: any = -1;
                    let sourceCols: any[] = [];
                    let targetPositions: any[] = [];
                    let originDefaultValue = "";

                    selectedColumn.items.map((selCol: any, rowIdx: number) => {
                      selCol.layout.map((_layout: any) => {
                        if (
                          selColLabel === _layout.template.label &&
                          _layout.template.type === "tb"
                        ) {
                          if (
                            !col?.objTable?.find((e: any) => e.Key === "id")
                          ) {
                            col.objTable.push({
                              Key: "id",
                              Template: null,
                              Value: "id",
                              TypeControl: "ShortText",
                              objTable: [],
                            });
                            col.column.push({
                              guid: "dzxlp2gpxoo99w1yo3m5yt",
                              label: "id",
                              alter: "",
                              control: {
                                template: {
                                  type: "t",
                                  label: "id",
                                  alter: "",
                                  attribute: {
                                    description: "",
                                    default: null,
                                    length: "0",
                                    require: "N",
                                    readonly: "N",
                                    widthInTable: "0",
                                    hideInPdf: "Y",
                                  },
                                },
                                data: {
                                  value: null,
                                },
                              },
                              isShow: false,
                            });
                          }

                          col.objTable?.map(
                            (objTable: any, tarColIdx: number) => {
                              if (objTable?.Value !== null) {
                                _layout.template.attribute.column.map(
                                  (refTable: any, colIdx: number) => {
                                    if (refTable.label?.trim()=== objTable.Value?.trim()) {
                                      // originDefaultValue =
                                      sourceRow = rowIdx;
                                      sourceCols.push({
                                        colIdx: colIdx,
                                      });
                                      targetPositions.push(tarColIdx);
                                    }
                                  }
                                );
                              }
                            }
                          );
                        }
                      });
                    });

                    if (sourceRow > -1) {
                      let tableRows: any[] = [];
                      if (refAttribute?.mode !== "Single") {
                        //adding if condition to check value of colcontrol
                        if (col.ControlValue) {
                          tableRows = col.ControlValue;
                        }
                      }

                      selectedColumn.items[sourceRow].layout[0]?.data?.row?.map(
                        (row: any) => {
                          let newRow: any[] = [];

                          for (let i = 0; i < col.objTable.length; i++) {
                            newRow.push({ value: null });
                          }

                          sourceCols.map((col: any, colIdx: number) => {
                            newRow[targetPositions[colIdx]] = row[col.colIdx];
                          });

                          if (newRow.length > 0) {
                            tableRows.push(newRow);
                          }
                        }
                      );

                      col.ControlValue = tableRows;
                    }
                  } else {
                    JSON.parse(refTems?.MAdvancveForm)?.items.map((selCol: any) => {
                      selCol.layout.map((_layout: any) => {
                        
                        if (_layout.template.label?.trim() === selColLabel?.trim()) {
                          col.ControlValue = _layout.data;
                   
                          
                        }
                      });
                    });
                  }
                }
                valibCol.push(col);
              }
            });
            // console.log(valibCol?.forEach((col)=>col.ControlValue.value =null) ,"test");
            // console.log(valibCol , valibCol.filter(item => item.ControlValue?.value !== "") ,"test");
            // console.log(valibCol,"test");
            valibCol = valibCol.filter(item => {

              if(!isDelete) return true
              // if (Array.isArray(item.ControlValue)) {
              //   console.log(item);
                
              //   return item.ControlValue.some(row => row.some(cell => cell.value !== null));
              // }

              if(item.TypeControl === "Table" && ( !_.isNull(item.ControlValue?.value) || !_.isEmpty(item.ControlValue?.value))) {

                return true
              }
              
              return (!_.isNull(item.ControlValue?.value) || !_.isEmpty(item.ControlValue?.value))  && item.ControlValue?.value !==''
            });
            
            
            if (isDelete && valibCol) {
              valibCol.forEach((col) => {
                if (col?.ControlValue) {
                  col.ControlValue.value = null;
            
                  if (Array.isArray(col.ControlValue.item)) {
                    col.ControlValue.item = col.ControlValue.item.map(() => "N");
                  }
                }
              });
            }
            
            
            console.log(isDelete ,valibCol,"test");
            
         valibCol.map((col: any) => {
              template_desc.map((item: any, rowIdx: number) => {
                item.layout.map((_layout: any, colIdx: number) => {
                  if (!col.ControlValue) return;

                  if (
                    col.TypeControl === "Table" &&
                    _layout.template.type === "tb"
                  ) {
                    if (col.Key === _layout.template.label) {
                      if (!_.isEqual(_layout.data.row, col.ControlValue)) {
                        let allRow: any[] = [];

                        col.ControlValue.map(
                          (refColValue: any, refRowIdx: number) => {
                            let newRows: { value: string | null }[] = [];

                            _layout.template.attribute.column.forEach(
                              (originCol: any, _colIdx: number) => {
                                let limitOnRef: any = null;
                                if (
                                  originCol.control.template.type === "c" &&
                                  originCol.control.template?.attribute
                                    ?.limitOnRef?.isactive
                                ) {
                                  if (
                                    memoDetail.status === "Draft" ||
                                    memoDetail.status === "New Request"
                                  ) {
                                    limitOnRef = {};
                                  } else {
                                    limitOnRef =
                                      originCol.control.template.attribute
                                        .limitOnRef;
                                  }
                                }
                                col.objTable.forEach(
                                  (refCol: any, valueIdx: number) => {
                                    if (refCol.Key?.trim() === originCol.label?.trim()) {
                                      if (refColValue[valueIdx]) {
                                        if (limitOnRef) {

                                          limitOnRef = {
                                            [refRowIdx]:
                                              refColValue[valueIdx].value,
                                          };
                                        }
                                        newRows[_colIdx] =
                                          refColValue[valueIdx];
                                      } else {
                                        console.log("Value is null or undefined", refColValue[valueIdx]);
                                        newRows[_colIdx] = { value: null };
                                      }
                                    }
                                  }
                                );
                                if (
                                  limitOnRef &&
                                  originCol.control.template?.attribute
                                    ?.limitOnRef?.isactive
                                ) {
                                  originCol.control.template.attribute.limitOnRef.tempValue =
                                    {
                                      ...originCol.control.template.attribute
                                        .limitOnRef.tempValue,
                                      ...limitOnRef,
                                    };
                                }
                              }
                            );
                            allRow.push(newRows);
                          }
                        );

                        const rowstateCol =
                          _layout.template.attribute.column.find(
                            (col: any) => col.label === "rowstate"
                          );
                        if (rowstateCol) {
                          col.ControlValue.map((e: { value: null }[]) => {
                            e.push({ value: null });
                            return e;
                          });
                        }
                        const filteredRows = allRow.filter(
                          (row) => Array.isArray(row) && !row.every((col) => col && col.value === null)
                        );

                        const cleanedRows = (!isDelete ? allRow : filteredRows).map(row =>
                          row.map((cell: { value: any; }) => {
                            if (cell && typeof cell === "object") {
                              return { value: cell.value ?? null }; 
                            }
                            return { value: null }; 
                          })
                        );
                        _layout.data.row = cleanedRows;


                      }
                    }
                  } else if (
                    col.TypeControl != "Table" &&
                    _layout.template.type != "l"
                  ) {
                    if (col.Key === _layout.template.label) {
                      
                      if (_layout.data?.value?.trim() !== col.ControlValue?.value?.trim()) {
                        _layout.data = col.ControlValue;
                      }
                    }
                  } else {
                    // Nothing do something because template type is heading
                  }
                });
              });
            });
            if (
              listFormNames.RefDocDisplay.split(",")[5] &&
              listFormNames.RefDocDisplay.split(",")[5] === "Yes"
            ) {
              let _res: any[] = [];
              await getMemoForAttch(refTems.MemoId, userData).then((e: any) => {
                if (e && Array.isArray(e)) {
                  if (!result.listFileAttachDetails) {
                    result.listFileAttachDetails = [];
                  }
                  result.listFileAttachDetails.push(...e);
                }
              });
            }
          }
          console.log({ template_desc });

          result.items = template_desc;
          result.listRefDocsDetail = _listRefDocsDetail;
        }
      }
    }
    console.log("ref=>result", { result });

    return result;
  } catch (error: any) {
    console.error("ref=>error", error);

    result.errorMessage = error;
    return result;
  }
};

const getMemoForAttch = async (memoId: number, userData: any) => {
  const requestBody = {
    memoid: memoId,
  };
  let res: any[] = [];
  await GetAttachmentFilesByMemoId(requestBody).then((e: any) => {
    res = e?.map((item: any) => {
      return {
        ...item,
        actor: userData,
      };
    });
  });
  return res;
};

export const fetchRefDocFormTable = async (memoDetail: any, template: any) => {
  let tempAtt = template.attribute;
  if (tempAtt !== undefined) {
    if (tempAtt.refdoc !== undefined) {
      const dataRequest = {
        PageIndex: 0,
        PageSize: 0,
        CUserID: memoDetail.creator.EmployeeId.toString(),
        RUserID: memoDetail.requestor.EmployeeId.toString(),
        ConditionRefdoc:
          tempAtt.conditionrefdoc.length > 0
            ? JSON.stringify(tempAtt.conditionrefdoc)
            : "",
        Search: "",
        docDataSource: tempAtt.refdoc.docDataSource,
        docReport: tempAtt.refdoc.docReport,
        docCancelDoc: tempAtt.refdoc.docCancelDoc,
        docEditDoc: tempAtt.refdoc.docEditDoc,
        docNewDoc: tempAtt.refdoc.docNewDoc,
        doccontrol: tempAtt.refdoc.doccontrol !== "N",
        docref: tempAtt.refdoc.docref,
      };

      const refDetails = await GetRefDocFormTable(dataRequest);

      if (refDetails) {
        if (refDetails?.dt_Report?.length > 0) {
          return refDetails.dt_Report;
        } else {
          return [];
        }
      }
    }
  }
};
